import gql from 'graphql-tag'

export const LOGIN = gql`
  mutation loginCheckAccess($username: String!, $password: String!) {
    login(username: $username, password: $password) {
      token
    }
  }
`

export const CHANGE_PASSWORD = gql`
  mutation accountChangeUserPassword(
    $username: String!
    $newPassword: String!
    $oldPassword: String!
  ) {
    changeUserPassword(username: $username, newPassword: $newPassword, oldPassword: $oldPassword)
  }
`

export const CHANGE_USER_STATUS = gql`
  mutation completePersonRegister($id: Int!) {
    completePersonRegister(id: $id)
  }
`

export const REQUEST_EMAIL_CODE = gql`
  mutation accountRequestUpdateEmailCode($newEmail: String!) {
    requestUpdateEmailCode(email: $newEmail)
  }
`

export const CHECK_EMAIL_CODE = gql`
  mutation accountCheckUpdateEmailCode($email: String!, $code: Int!) {
    checkUpdateEmailCode(email: $email, code: $code)
  }
`

export const CHECK_EMAIL_INVITE_RESPONSIBLE = gql`
  mutation checkEmailInviteResponsible($email: String!) {
    checkEmailInviteResponsible(email: $email)
  }
`
export const ADD_RESPONSIBLE = gql`
  mutation addResponsible($email: String!, $mobile: String, $name: String, $dependentId: Int) {
    addResponsible(email: $email, mobile: $mobile, name: $name, dependentId: $dependentId)
  }
`

export const CHECK_EMAIL = gql`
  mutation accountCheckEmail($email: String!) {
    checkEmail(email: $email)
  }
`

export const CHECK_MOBILE = gql`
  mutation checkMobile($mobile: Int!) {
    checkMobile(mobile: $mobile)
  }
`

export const REQUEST_MOBILE_CODE = gql`
  mutation requestMobileCode($mobile: Int!, $name: String!) {
    requestMobileCode(mobile: $mobile, name: $name)
  }
`

export const CHECK_MOBILE_CODE = gql`
  mutation checkMobileCode($mobile: Int!, $code: Int!) {
    checkMobileCode(mobile: $mobile, code: $code)
  }
`

export const CHANGE_EMAIL_BY_CODE = gql`
  mutation accountChangeEmailByCode($email: String!, $code: Int!) {
    changeEmailByCode(email: $email, code: $code)
  }
`

export const UPDATE_PERSON_NAME = gql`
  mutation accountUpdatePersonName(
    $id: Int!
    $email: String
    $name: String!
    $newUsername: String
  ) {
    updatePerson(id: $id, email: $email, name: $name, newUsername: $newUsername) {
      id
      name
      email
      schools {
        id
        tradeName
        isManageable
      }
      pisco {
        code
        hasAccess
      }
      users {
        id
        username
        personId
        typeUserId
      }
      contacts {
        ddd
        number
      }
    }
  }
`

export const UPDATE_PERSON_USERNAME = gql`
  mutation accountUpdatePersonUsername(
    $id: Int!
    $name: String!
    $oldUsername: String
    $newUsername: String!
    $email: String
  ) {
    updatePerson(
      id: $id
      name: $name
      oldUsername: $oldUsername
      newUsername: $newUsername
      email: $email
    ) {
      id
      name
      email
      schools {
        id
        tradeName
        isManageable
      }
      pisco {
        code
        hasAccess
      }
      users {
        id
        username
        personId
        typeUserId
      }
      contacts {
        ddd
        number
      }
    }
  }
`

export const UPDATE_PERSON_MOBILE = gql`
  mutation updatePersonMobile($mobile: Int!, $mobileCode: Int!) {
    saveMobile(mobile: $mobile, mobileCode: $mobileCode) {
      id
    }
  }
`

export const SCHOOL_ADD_DIRECTOR = gql`
  mutation accountSchoolAddDirector($schoolId: Int!) {
    schoolAddDirector(schoolId: $schoolId) {
      id
    }
  }
`

export const SCHOOL_ADD_ADMIN = gql`
  mutation accountSchoolAddAdmin($schoolId: Int!) {
    schoolAddAdmin(schoolId: $schoolId) {
      id
    }
  }
`

export const SCHOOL_REMOVE_TEACHER = gql`
  mutation accountSchoolRemoveTeacher($schoolId: Int!) {
    schoolRemoveTeacher(schoolId: $schoolId) {
      id
    }
  }
`

export const SCHOOL_REMOVE_DIRECTOR = gql`
  mutation accountSchoolRemoveDirector($schoolId: Int!) {
    schoolRemoveDirector(schoolId: $schoolId) {
      id
    }
  }
`

export const SCHOOL_REMOVE_ADMIN = gql`
  mutation accountSchoolRemoveAdmin($schoolId: Int!) {
    schoolRemoveAdmin(schoolId: $schoolId) {
      id
    }
  }
`

export const SCHOOL_REMOVE_COORDINATOR = gql`
  mutation accountSchoolRemoveCoordinator($schoolId: Int!) {
    schoolRemoveCoordinator(schoolId: $schoolId) {
      id
    }
  }
`

export const SCHOOL_ADD_TEACHER = gql`
  mutation accountSchoolAddTeacher($schoolId: Int!, $levels: [String!]) {
    schoolAddTeacher(schoolId: $schoolId, levels: $levels) {
      id
    }
  }
`

export const SCHOOL_ADD_COORDINATOR = gql`
  mutation accountSchoolAddCoordinator($schoolId: Int!, $levels: [String!]) {
    schoolAddCoordinator(schoolId: $schoolId, levels: $levels) {
      id
    }
  }
`
export const USE_ACCESS_CODE = gql`
  mutation accountUseAccessCode($accessCode: String!) {
    useAccessCode(accessCode: $accessCode) {
      accessCode
      createdAt
      products {
        id
        title
      }
      school {
        id
        legalName
        tradeName
        cnpj
      }
      class {
        id
        name
        school {
          id
          tradeName
        }
      }
    }
  }
`

export const ADD_DEPENDENT = gql`
  mutation accountAddDependent($dependentUuid: String!) {
    addDependent(dependentUuid: $dependentUuid)
  }
`

export const REMOVE_RELATED_DEPENDENT = gql`
  mutation removeRelatedDependent($parentId: Int!, $studentId: Int!) {
    removeRelatedUsers(parentID: $parentId, studentId: $studentId)
  }
`

export const TOGGLE_PRIVACY_PREFERENCES = gql`
  mutation toggleUserPrivacyPreferences($input: PrivacyPreferenceInput!) {
    toggleUserPrivacyPreferences(input: $input) {
      somosId
      type
      channels {
        channel
        optOutDate
      }
    }
  }
`

export const ACCEPT_TERM_OF_USE = gql`
  mutation accountAcceptTermOfUse($id: Int!) {
    acceptTermOfUse(id: $id)
  }
`
